import { render } from "./MainTabbar.vue?vue&type=template&id=f2241af0&scoped=true"
import script from "./MainTabbar.vue?vue&type=script&lang=js"
export * from "./MainTabbar.vue?vue&type=script&lang=js"

import "./MainTabbar.vue?vue&type=style&index=0&id=f2241af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2241af0"]])

export default __exports__